import { SourceCard } from './SourceCard'

interface SourcesListProps {
    chunks: any[]
}

export function SourcesList({ chunks }: SourcesListProps) {
    if (!chunks || chunks.length === 0) return null

    return (
        <div className="mt-6">
            <h3 className="text-sm font-medium text-gray-400 mb-3 uppercase tracking-wider flex items-center gap-2">
                Retrieved Context <span className="bg-white/10 text-white px-1.5 py-0.5 rounded text-[10px]">{chunks.length}</span>
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {chunks.map((chunk: any, i: number) => (
                    <SourceCard key={i} chunk={chunk} index={i} />
                ))}
            </div>
        </div>
    )
}
